import Component from '../abstracts/Component';
import { Select2Init } from "../utils/Select2Init";

export default class PrivacyUnsubscribeComponent extends Component {

  get SELECTORS() {
    return {
      radioTriggerNo: '[data-js-radio-trigger-no]',
      radioTriggerYes: '[data-js-radio-trigger-yes]',
    };
  }

  constructor(htmlEl) {
    super(htmlEl);
  }

  readDOM() {
    return {
      radioTriggersNo: this.$component.querySelectorAll(this.SELECTORS.radioTriggerNo),
      radioTriggersYes: this.$component.querySelectorAll(this.SELECTORS.radioTriggerYes)
    };
  }

  handleRadioClick() {
    if(this.dom.radioTriggersNo) {
      this.dom.radioTriggersNo.forEach(trigger => {
        trigger.addEventListener("change", event => {
          if(trigger.checked) {
            const index = trigger.dataset.jsRadioTriggerNo;
            const select = this.$component.querySelector('[data-js-select="' + index + '"]');
            select.classList.remove("hidden");
            this.setCollapsedHeight(trigger);
          }
        });
      });
    }
    if(this.dom.radioTriggersYes) {
      this.dom.radioTriggersYes.forEach(trigger => {
        trigger.addEventListener("change", event => {
          if(trigger.checked) {
            const index = trigger.dataset.jsRadioTriggerYes;
            const select = this.$component.querySelector('[data-js-select="' + index + '"]');
            select.classList.add("hidden");
            this.setCollapsedHeight(trigger);
          }
        });
      });
    }
  }

  setCollapsedHeight(radioButton) {
    const tab = radioButton.closest("[data-tab]");
    //rest height
    tab.style.height = null;
    tab.style.height = tab.offsetHeight + "px";
  }

  render() {
    this.log("Rendering...");
    this.dom = this.readDOM();
    this.handleRadioClick();
    Select2Init();
  }
}
